'use strict';
import _ from 'lodash-es';
import inventory  from './';
import util  from '../util';

var newLine = '\n';

var pdpStoreTemplate = function (store) {
	return [
		'<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
		'    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
		' ' + store.postalCode + '</div>',
		'    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
		'</li>'
	].join(newLine);
};
var pdpStoresListingTemplate = function (stores) {
	if (stores && stores.length) {
		return [
			'<div class="store-list-pdp-container">',
			(stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
			'    <ul class="store-list-pdp">',
			_.map(stores, pdpStoreTemplate).join(newLine),
			'    </ul>',
			'</div>'
		].join(newLine);
	}
};

var storesListing = function (stores) {
	// list all stores on PDP page
	if ($('.store-list-pdp-container').length) {
		$('.store-list-pdp-container').remove();
	}
	$('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
	setPreferredStore: function (storeId) {
		User.storeId = storeId;
		$.ajax({
			url: Urls.setPreferredStore,
			type: 'POST',
			data: {
				storeId: storeId
			}
		});
	},
	productSelectStore: function () {
		var self = this;
		inventory.getStoresInventory(this.pid).then(function (stores) {
			inventory.selectStoreDialog({
				stores: stores,
				selectedStoreId: User.storeId,
				selectedStoreText: Resources.PREFERRED_STORE,
				continueCallback: storesListing,
				selectStoreCallback: self.setPreferredStore
			});
		}).done();
	},
	init: function () {
		var $availabilityContainer = $('.availability-results'),
			self = this;
		this.pid = $('input[name="pid"]').val();

		$('#product-content .set-preferred-store').on('click', function (e) {
			e.preventDefault();
			if (!User.zip) {
				inventory.zipPrompt(function () {
					self.productSelectStore();
				});
			} else {
				self.productSelectStore();
			}
		});

		if ($availabilityContainer.length) {
			if (User.storeId) {
				inventory.getStoresInventory(this.pid).then(storesListing);
			}

			// See more or less stores in the listing
			$availabilityContainer.on('click', '.stores-toggle', function (e) {
				e.preventDefault();
				$('.store-list-pdp .store-list-item').toggleClass('visible');
				if ($(this).hasClass('collapsed')) {
					$(this).text(Resources.SEE_LESS);
				} else {
					$(this).text(Resources.SEE_MORE);
				}
				$(this).toggleClass('collapsed');
			});
		}

		productPackshotRegimen();
	}
};

export default productInventory;

$('img.product-image-initial').bind('mouseenter mouseleave', function () {
	$(this).attr({
		src: $(this).attr('data-alt-src'),
		'data-alt-src': $(this).attr('src')
	})
});

$('#product-list-page-carousel').slick({
	dots: false,
	infinite: false,
	speed: 300,
	slidesToShow: 1,
	slidesToScroll: 1,
	responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});

$('#product-image-carousel').slick({
	dots: false,
	infinite: false,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});

$('#product-video-carousel').slick({
	dots: false,
	infinite: false,
	speed: 300,
	slidesToShow: 3,
	slidesToScroll: 3,
	responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	]
});

function isScrolledIntoView(elem) {
	var $elem = $(elem),
		$window = $(window),
		docViewTop = $window.scrollTop(),
		docViewBottom = docViewTop + $window.height(),
		elemTop = $elem.offset().top,
		elemBottom = elemTop + $elem.height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * @description PDP Sticky Navigation and Sticky Buy Desktop
 **/
if ($('.pdp-jump-links').length) {
	var pdpnavbar = $('.pdp-jump-links'),
		moduleLength = pdpnavbar.find('.link-wrapper li').length;
	if (moduleLength <= 1) {
		$('.pdp-jump-links').remove();
	} else {
		$('.pdp-jump-links').removeClass('d-none');
	}

	var sticky = pdpnavbar.offset().top;
}

function productStickyNav() {
	if ($('.pdp-jump-links').length) {
		if ($(window).scrollTop() >= sticky) {
			pdpnavbar.addClass('sticky');
			window.setTimeout(function () {
				pdpnavbar.addClass('animation');
			}, 100);
		} else {
			pdpnavbar.removeClass('sticky animation');
			$('.stick-buy-container').removeClass('open');
			$('.sticky-buy-link').removeClass('active');
		}
	}
}

/**
 * @description PDP Sticky Buy Mobile
 **/
if ($('.sticky-buy-mobile').length) {
	var stickyBuyMobile = $('.sticky-buy-mobile'),
		addToCartButtonWrapper = $('.product-details-wrapper .product-add-to-cart'),
		addToCartButtonPosition = addToCartButtonWrapper.offset().top;

	$('.sticky-buy-mobile').on('click', function () {
		var scrollPosition = (addToCartButtonWrapper.offset().top + addToCartButtonWrapper.height()) - $(window).height();
		$('html, body').animate({
			scrollTop: scrollPosition
		}, 500);
	});
}

function productStickyBuyMobile() {
	if ($('.sticky-buy-mobile').length) {
		if ($(window).scrollTop() >= addToCartButtonPosition && !isScrolledIntoView(addToCartButtonWrapper)) {
			stickyBuyMobile.addClass('sticky');
		} else {
			stickyBuyMobile.removeClass('sticky');
		}
	}
}

$(document).on('click', '.sticky-buy-link, .stick-buy-outer-close', function () {
	$('.sticky-buy-link').toggleClass('active');
	$('.stick-buy-container').toggleClass('open');
	$('.swatches-dropdown, #pdp-swatches').removeClass('active');
});

function productPackshotRegimen() {
	if ($(window).width() <= 768) {
		$('.routine-product-title.empty') && $('.routine-product-title.empty').parents('.product-tile-wrapper').find('.product-packshot-wrapper').addClass('no-space');
	}
}

$(window).on('resize orientationchange', function () {
	productStickyNav();
	productStickyBuyMobile();
	productPackshotRegimen();
});

$(window).on('scroll', function () {
	productStickyNav();
	productStickyBuyMobile();
});

$('#product-list-page-carousel > .slick-arrow').click(function () {
	$('.product-list-carousel > iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
});
